import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import i18n from 'i18n-js';
import moment from 'moment';
import { forceTimezone } from 'utils';
import { Box } from '@material-ui/core';
import Loading from 'components/Loading';
import { Table, Card } from 'components/UI';
import Paginator from 'components/Paginator';
import { BusinessHoursActions } from 'state/modules/businessHours';

const AssociatedVehileGroups = ({ id }) => {
  const dispatch = useDispatch();
  const [params, setParams] = useState({
    page: 1,
    limit: 5,
  });

  const { loading, associatedVehileGroups, associatedVehileGroupsPagination } = useSelector(
    (state) => state.businessHours
  );
  const { localeFormat } = useSelector((state) => state.organizations);

  useEffect(() => {
    if (id) {
      dispatch(BusinessHoursActions.fetchAssociatedVehicleGroups(id, params));
    }
  }, [id, params]);  // eslint-disable-line

  const handlePageChange = (event, page) => {
    const newParams = { page: page + 1, limit: params.limit };
    setParams({ ...params, ...newParams });
  };

  /**
   * Table columns
   */
  const columns = [
    {
      name: i18n.t('common.vehicle_group'),
      selector: 'name',
    },
    {
      name: i18n.t('common.start_date'),
      selector: (row) =>
        row?.start_time ? forceTimezone(moment(row?.start_time)).format(localeFormat) : '',
    },
    {
      name: i18n.t('common.end_date'),
      selector: (row) =>
        row?.end_time ? forceTimezone(moment(row?.end_time)).format(localeFormat) : '--',
    },
  ];

  return (
    <Card
      headerActionType="vertical"
      data-cy="associated-groups-widget-card"
      title={i18n.t('ruleset.associated_vg')}
    >
      {loading ? (
        <Box justifyContent="center" alignItems="center" display="flex">
          <Loading />
        </Box>
      ) : (
        <>
          <Table
            columns={columns}
            pagination={false}
            data={associatedVehileGroups}
            paginationComponentOptions={{ noRowsPerPage: true }}
          />
          <Paginator
            component="div"
            limit={params.limit}
            onPageChange={handlePageChange}
            pagination={associatedVehileGroupsPagination}
          />
        </>
      )}
    </Card>
  );
};

export default AssociatedVehileGroups;
